import {
    buildSearchUrl,
} from 'wanderu-utils';

import {
    DEPART_DIRECTION,
    RETURN_DIRECTION,
} from '../../constants';

import type { TripSummaryProps } from './types';

function buildReturnUrl(props: TripSummaryProps, unavailableTrips: string[]) {
    const {
        outboundTripIds = [],
    } = props;

    const unavailableOutbound = unavailableTrips.some(
        (tripId) => outboundTripIds.includes(tripId),
    );

    if (unavailableOutbound) {
        return createSearchUrl(props, DEPART_DIRECTION);
    }

    return createSearchUrl(props, RETURN_DIRECTION);
}


function createSearchUrl(props: TripSummaryProps, direction: string) {
    const {
        destinationPlaceId,
        originPlaceId,
        outboundArrive = {},
        outboundDepart = {},
        outboundTripId,
        returnDepart = {},
        searchQueries = {},
        urlFilterParams,
    } = props;
    const {
        departDate: queryDepartDate,
        dpid: queryDestinationPlaceId,
        opid: queryOriginPlaceId,
        returnDate: queryReturnDate,
    } = searchQueries;
    const {
        cityName: departCityName,
        localizedDateTime: departDate,
        region: departRegion,
    } = outboundDepart;
    const {
        cityName: arriveCityName,
        region: arriveRegion,
    } = outboundArrive;

    let returnDate;
    if (returnDepart) {
        returnDate = returnDepart.localizedDateTime;
    }

    const originText = !!departCityName && !!departRegion
        ? `${departCityName} ${departRegion}`
        : 'a';

    const destinationText = !!arriveCityName && !!arriveRegion
        ? `${arriveCityName} ${arriveRegion}`
        : 'b';

    const opts = {
        departDate: queryDepartDate || departDate,
        departTripId: outboundTripId,
        destinationPlaceId: destinationPlaceId || queryDestinationPlaceId,
        destinationText,
        direction,
        originPlaceId: originPlaceId || queryOriginPlaceId,
        originText,
        returnDate: queryReturnDate || returnDate,
    };

    return buildSearchUrl(opts, urlFilterParams);
}

export {
    buildReturnUrl,
    createSearchUrl,
};
